import axios from "axios";
import authHeader from '../../authheader.js';
import dayjs from 'dayjs';
import { getAdditionalStructurals, getEngineerExamDiscipline, getFirstExamDiscipline, getStates, getSurveyingExamDiscipline } from '../../../services/Shared/codeTable.service'

const SUMMARYSHEETURL = process.env.REACT_APP_APIURL + "/api/SummarySheet";

const mapBaseSectionToJsObject = (section) => {
    var violations = [];
    if (section.isViolationsApp)
        violations.push('App')
    if (section.isViolationsFA)
        violations.push('FA')
    if (section.isViolationsNCEES)
        violations.push('NCEES')
    if (section.isViolationsCAVU)
        violations.push('CAVU')
    var firmLicensure = [];
    if (section.isFirmLicensureActiveWithLapels)
        firmLicensure.push('ActiveWithLapels')
    if (section.isFirmLicensureNotWithLapels)
        firmLicensure.push('NotWithLapels')
    if (section.isFirmLicensureSoleProprietor)
        firmLicensure.push('SoleProprietor')
    if (section.isFirmLicensureSeekingEmployment)
        firmLicensure.push('SeekingEmployment')

    var obj = {
        ...section,
        violations,
        firmLicensure,
        dateReceived: section.dateReceived != null ? dayjs(section.dateReceived).format('YYYY-MM-DD') : null,
    }
    return obj
}

const mapJsObjectToBaseSection = (section) => {
    section.isViolationsApp = section.violations.includes('App')
    section.isViolationsFA = section.violations.includes('FA')
    section.isViolationsNCEES = section.violations.includes('NCEES')
    section.isViolationsCAVU = section.violations.includes('CAVU')

    section.isFirmLicensureActiveWithLapels = section.firmLicensure.includes('ActiveWithLapels')
    section.isFirmLicensureNotWithLapels = section.firmLicensure.includes('NotWithLapels')
    section.isFirmLicensureSoleProprietor = section.firmLicensure.includes('SoleProprietor')
    section.isFirmLicensureSeekingEmployment = section.firmLicensure.includes('SeekingEmployment')

    section.dateReceived = section.dateReceived ? dayjs(section.dateReceived).format('YYYY-MM-DD') : null;

    if (section.peExamViewModel != null) {
        section.peExamViewModel.applicationDisciplineId = section.applicationDiscipline?.id;
        section.peExamViewModel.comityStateId = section.comityState?.id;
        section.peExamViewModel.eicertificationDate = section.eiCertificationDate ? dayjs(section.eiCertificationDate).format('YYYY-MM-DD') : null;
        section.peExamViewModel.eicertificationNumber = section.eiCertificationNumber;
        section.peExamViewModel.feexamDate = section.feExamDate ? dayjs(section.feExamDate).format('YYYY-MM-DD') : null;
        section.peExamViewModel.feexamStateId = section.feExamState?.id;
        section.peExamViewModel.peexamDate = section.peExamDate ? dayjs(section.peExamDate).format('YYYY-MM-DD') : null;
        section.peExamViewModel.peexamStateId = section.peExamState?.id;
        section.peExamViewModel.pelicenseStateId = section.peLicenseState?.id;
        section.peExamViewModel.pelicenseDate = section.peLicenseDate ? dayjs(section.peLicenseDate).format('YYYY-MM-DD') : null;
        section.peExamViewModel.pelicenseNumber = section.peLicenseNumber;
        section.peExamViewModel.peexamDisciplineId = section.peExamDiscipline?.id;
        section.peExamViewModel.disciplineTwoId = section.peExamDiscipline2?.id;
        section.peExamViewModel.disciplineTwoRegistrationDate = section.peExamDiscipline2RegistrationDate ? dayjs(section.peExamDiscipline2RegistrationDate).format('YYYY-MM-DD') : null;
        section.peExamViewModel.disciplineTwoExamStateId = section.peExamDiscipline2ExamState?.id;
        section.peExamViewModel.examAdditionalStructuralId = section.additionalStructural1?.id;
        section.peExamViewModel.examAdditionalStructuralDate = section.additionalStructuralExamDate1 ? dayjs(section.additionalStructuralExamDate1).format('YYYY-MM-DD') : null;
        section.peExamViewModel.examAdditionalStructuralTwoId = section.additionalStructural2?.id;
        section.peExamViewModel.examAdditionalStructuralDateTwo = section.additionalStructuralExamDate2 ? dayjs(section.additionalStructuralExamDate2).format('YYYY-MM-DD') : null;
        section.peExamViewModel.isAct2 = section.isAct2;
        section.peExamViewModel.isByEndorsement = section.isByEndorsement;
        section.peExamViewModel.isModelLaw = section.isModelLaw;
        section.peExamViewModel.entityId = section.entityId;
        section.peExamViewModel.sectionId = section.id ?? 0;
    }
    else if (section.plsExamViewModel != null) {
        section.plsExamViewModel.commityStateId = section.comityState?.id;
        section.plsExamViewModel.fsexamStateId = section.fsExamState?.id;
        section.plsExamViewModel.fsexamDate = section.fsExamDate ? dayjs(section.fsExamDate).format('YYYY-MM-DD') : null;
        section.plsExamViewModel.lalawsExamDate = section.laLawsExamDate ? dayjs(section.laLawsExamDate).format('YYYY-MM-DD') : null;
        section.plsExamViewModel.lsicertDate = section.lsiCertDate ? dayjs(section.lsiCertDate).format('YYYY-MM-DD') : null;
        section.plsExamViewModel.lsicertNumber = section.lsiCertNumber;
        section.plsExamViewModel.oralExamDate = section.oralExamDate ? dayjs(section.oralExamDate).format('YYYY-MM-DD') : null;
        section.plsExamViewModel.plsexamDate = section.plsExamDate ? dayjs(section.plsExamDate).format('YYYY-MM-DD') : null;
        section.plsExamViewModel.plsexamDisciplineId = section.plsExamDiscipline?.id;
        section.plsExamViewModel.plsexamStateId = section.plsExamState?.id;
        section.plsExamViewModel.plslicenseDate = section.plsLicenseDate ? dayjs(section.plsLicenseDate).format('YYYY-MM-DD') : null;
        section.plsExamViewModel.plslicenseNumber = section.plsLicenseNumber;
        section.plsExamViewModel.isAct2 = section.isAct2;
        section.plsExamViewModel.isByEndorsement = section.isByEndorsement;
        section.plsExamViewModel.isModelLaw = section.isModelLaw;
        section.plsExamViewModel.plslicenseStateId = section.plsLicenseState?.id;
        section.plsExamViewModel.sectionId = section.id ?? 0;
        section.plsExamViewModel.entityId = section.entityId
    }
    return section;
}

const mapPeExamObject = async (data) => {
    var sections = await Promise.all(data.sections.map(async (val, i) => {
        var obj = mapBaseSectionToJsObject(val);
        if (val.peExamViewModel != null && (val.sectionTypeId == 16 || val.sectionTypeId == 20 || val.sectionTypeId == 40 || val.sectionTypeId == 21))//PassedPeExam, verification of cert, Passed Examination
        {
            const [states, examDiscipline, appDiscipline, additionalStructural] = await Promise.all([getStates(), getEngineerExamDiscipline(), getFirstExamDiscipline(), getAdditionalStructurals()]);
            obj = {
                ...obj,
                applicationDiscipline: appDiscipline.find(obj => { return obj.value.id == val.peExamViewModel.applicationDisciplineId })?.value,
                comityState: states.find(obj => { return obj.value.id == val.peExamViewModel.comityStateId })?.value,
                eiCertificationDate: val.peExamViewModel.eicertificationDate ? dayjs(val.peExamViewModel.eicertificationDate).format('YYYY-MM-DD') : null,
                eiCertificationNumber: val.peExamViewModel.eicertificationNumber,
                feExamDate: val.peExamViewModel.feexamDate ? dayjs(val.peExamViewModel.feexamDate).format('YYYY-MM-DD') : null,
                feExamState: states.find(obj => { return obj.value.id == val.peExamViewModel.feexamStateId })?.value,
                peExamDate: val.peExamViewModel.peexamDate ? dayjs(val.peExamViewModel.peexamDate).format('YYYY-MM-DD') : null,
                peExamState: states.find(obj => { return obj.value.id == val.peExamViewModel.peexamStateId })?.value,
                peLicenseState: states.find(obj => { return obj.value.id == val.peExamViewModel.pelicenseStateId })?.value,
                peLicenseDate: val.peExamViewModel.pelicenseDate ? dayjs(val.peExamViewModel.pelicenseDate).format('YYYY-MM-DD') : null,
                peLicenseNumber: val.peExamViewModel.pelicenseNumber,
                peExamDiscipline: examDiscipline.find(obj => { return obj.value.id == val.peExamViewModel.peexamDisciplineId })?.value,
                peExamDiscipline2: appDiscipline.find(obj => { return obj.value.id == val.peExamViewModel.disciplineTwoId })?.value,
                peExamDiscipline2RegistrationDate: val.peExamViewModel.disciplineTwoRegistrationDate ? dayjs(val.peExamViewModel.disciplineTwoRegistrationDate).format('YYYY-MM-DD') : null,
                peExamDiscipline2ExamState: states.find(obj => { return obj.value.id == val.peExamViewModel.disciplineTwoExamStateId })?.value,
                isAct2: val.peExamViewModel.isAct2,
                isByEndorsement: val.peExamViewModel.isByEndorsement,
                isModelLaw: val.peExamViewModel.isModelLaw,
                additionalStructural1: additionalStructural.find(obj => { return obj.value.id == val.peExamViewModel.examAdditionalStructuralId })?.value,
                additionalStructuralExamDate1: val.peExamViewModel.examAdditionalStructuralDate ? dayjs(val.peExamViewModel.examAdditionalStructuralDate).format('YYYY-MM-DD') : null,
                additionalStructural2: additionalStructural.find(obj => { return obj.value.id == val.peExamViewModel.examAdditionalStructuralTwoId })?.value,
                additionalStructuralExamDate2: val.peExamViewModel.examAdditionalStructuralDateTwo ? dayjs(val.peExamViewModel.examAdditionalStructuralDateTwo).format('YYYY-MM-DD') : null,
                entityId: val.peExamViewModel.entityId
            }
        }
        else if (val.plsExamViewModel != null && (val.sectionTypeId == 20 || val.sectionTypeId == 6 || val.sectionTypeId == 21 || val.sectionTypeId == 40))//Verification of Certification, Ncees PS Exam, Verification of Licensture
        {
            const [states, examDiscipline] = await Promise.all([getStates(), getSurveyingExamDiscipline()]);
            obj = {
                ...obj,
                comityState: states.find(obj => { return obj.value.id == val.plsExamViewModel.commityStateId })?.value,
                lsiCertDate: val.plsExamViewModel.lsicertDate ? dayjs(val.plsExamViewModel.lsicertDate).format('YYYY-MM-DD') : null,
                fsExamState: states.find(obj => { return obj.value.id == val.plsExamViewModel.fsexamStateId })?.value,
                fsExamDate: val.plsExamViewModel.fsexamDate ? dayjs(val.plsExamViewModel.fsexamDate).format('YYYY-MM-DD') : null,
                laLawsExamDate: val.plsExamViewModel.lalawsExamDate ? dayjs(val.plsExamViewModel.lalawsExamDate).format('YYYY-MM-DD') : null,
                lsiCertNumber: val.plsExamViewModel.lsicertNumber,
                oralExamDate: val.plsExamViewModel.oralExamDate ? dayjs(val.plsExamViewModel.oralExamDate).format('YYYY-MM-DD') : null,
                plsExamDate: val.plsExamViewModel.plsexamDate ? dayjs(val.plsExamViewModel.plsexamDate).format('YYYY-MM-DD') : null,
                plsExamDiscipline: examDiscipline.find(obj => { return obj.value.id == val.plsExamViewModel.plsexamDisciplineId })?.value,
                plsExamState: states.find(obj => { return obj.value.id == val.plsExamViewModel.plsexamStateId })?.value,
                plsLicenseDate: val.plsExamViewModel.plslicenseDate != null ? dayjs(val.plsExamViewModel.plslicenseDate).format('YYYY-MM-DD') : null,
                plsLicenseNumber: val.plsExamViewModel.plslicenseNumber,
                isModelLaw: val.plsExamViewModel.isModelLaw,
                isAct2: val.plsExamViewModel.isAct2,
                isByEndorsement: val.plsExamViewModel.isByEndorsement,
                plsLicenseState: states.find(obj => { return obj.value.id == val.plsExamViewModel.plslicenseStateId })?.value,
                entityId: val.plsExamViewModel.entityId
            }
        }
        return obj;
    }))
    var model = {
        ...data,
        sections: sections,
        dateReceived: data.dateReceived != null ? dayjs(data.dateReceived).format('YYYY-MM-DD') : null,
        dateCompleted: data.dateCompleted != null ? dayjs(data.dateCompleted).format('YYYY-MM-DD') : null,
        dateSentForReview: data.dateSentForReview != null ? dayjs(data.dateSentForReview).format('YYYY-MM-DD') : null,
        dateCrte: data.dateCrte != null ? dayjs(data.dateCrte).format('YYYY-MM-DD') : null
    };
    return model;
}

const getSummarySheet = (parentId, parentTypeId, summaryTypeId, entityId) => {
    return axios.get(`${SUMMARYSHEETURL}/getsummary`, { headers: authHeader(), params: { parentId, parentTypeId, summaryTypeId, entityId } }).then((response) => {
        return mapPeExamObject(response.data)
    });
}

const updateEntireExamModel = (vm) => {
    vm.sections = vm.sections.map((val, i) => {
        return mapJsObjectToBaseSection(val);
    })
    vm.dateReceived = vm.dateReceived ? dayjs(vm.dateReceived).format('YYYY-MM-DD') : null;
    vm.dateCompleted = vm.dateCompleted ? dayjs(vm.dateCompleted).format('YYYY-MM-DD') : null;
    vm.dateSentForReview = vm.dateSentForReview ? dayjs(vm.dateSentForReview).format('YYYY-MM-DD') : null;

    return axios.post(`${SUMMARYSHEETURL}/updatesummary`, vm, { headers: authHeader() });
}

const updateSection = async (vm) => {
    return axios.post(`${SUMMARYSHEETURL}/updatesection`, mapJsObjectToBaseSection(vm), { headers: authHeader() });
}
const getSummarySheetTypeId = (parentId, parentTypeId) => {
    return axios.get(`${SUMMARYSHEETURL}/getsummarytypeid`, { headers: authHeader(), params: { parentId, parentTypeId } });
}
const getSummaryTypes = (applicationTypeId, parentTypeId) => {
    return axios.get(`${SUMMARYSHEETURL}/getcodesummarytypes`, { headers: authHeader(), params: { applicationTypeId, parentTypeId } });
}
export default { getSummarySheet, updateEntireExamModel, getSummarySheetTypeId, updateSection, getSummaryTypes }